import * as types from "../../constants/constants";

export const EditProfileRequest = () => ({
  type: types.EDIT_PROFILE_REQUEST,
});

export const EditProfileSuccess = (payload) => {
  return {
    type: types.EDIT_PROFILE_SUCCESS,
    payload
  }
  
};

export const EditProfileFailure = (error) => ({
  type: types.EDIT_PROFILE_FAILURE,
  payload: error,
});

export const getProfileRequest = () => ({
  type: types.GET_PROFILE_REQUEST,
});

export const getProfileSuccess = (payload) => ({
  type: types.GET_PROFILE_SUCCESS,
  payload,
});

export const getProfileFailure = (error) => ({
  type: types.GET_PROFILE_FAILURE,
  payload: error,
});
export const getAvatarRequest = () => ({
  type: types.GET_AVATAR_REQUEST,
});

export const getAvatarSuccess = (payload) => ({
  type: types.GET_AVATAR_SUCCESS,
  payload,
});

export const getAvatarFailure = (error) => ({
  type: types.GET_AVATAR_FAILURE,
  payload: error,
});